import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Http } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NvD3Module } from 'ng2-nvd3';

import 'd3';
import 'nvd3';

import { Globals } from './_shared/services/globals';
import { MsalService } from './_shared/services/msal.service';
import { MsalGuard } from './_shared/guards/msal.guard';
import { ConfigService } from './_shared/services/config.service';
import { configServiceLoader } from './_shared/services/config.serviceFactory';
import { EnergyDataService } from './_shared/services/energy-data.service';
import { MonitoringService } from './_shared/services/monitoring.service';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './_shared/navmenu/navmenu.component';
import { MyEnergyComponent } from './pages/my-energy/my-energy.component';
import { IslandEnergyComponent } from './pages/island-energy/island-energy.component';
import { MobileEnergyComponent } from './pages/mobile-energy/mobile-energy.component';
import { GraphWideComponent } from './pages/_shared/graph-wide/graph-wide.component';
import { LineChartComponent } from './pages/_shared/line-chart/line-chart.component';
import { DataBlockComponent } from './pages/_shared/data-block/data-block.component';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';

// Force loading of fonts, which will be copied to wwwroot/dist folder by web pack
// TODO: figure out way to let angular/webpack load css and move it to ClientApp folder. Currently using _Layout.cshtml
import '../style.css';

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        MyEnergyComponent,
        IslandEnergyComponent,
        MobileEnergyComponent,
        GraphWideComponent,
        LineChartComponent,
        DataBlockComponent,
        LoginComponent,
        LogoutComponent
    ],
    imports: [
        CommonModule,
        HttpModule,
        FormsModule,
        NvD3Module,
        RouterModule.forRoot([
            { path: '', redirectTo: 'island', pathMatch: 'full' },
            { path: 'island', component: IslandEnergyComponent, canActivate: [MsalGuard] },
            { path: 'myenergy', component: MyEnergyComponent, canActivate: [MsalGuard] },
            { path: 'dashboard', component: MobileEnergyComponent, canActivate: [MsalGuard] },
            { path: 'login', component: LoginComponent },
            { path: 'logout', component: LogoutComponent },
            { path: '**', redirectTo: 'island' }
        ], { enableTracing: true })
    ],
    providers: [
        Globals,
        MsalService,
        MsalGuard,
        EnergyDataService,
        MonitoringService,
        // Config loading based on: https://stackoverflow.com/questions/38300116/angular2-load-configuration-from-backend-on-startup
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: configServiceLoader,
            deps: [ConfigService],
            multi: true
        }
    ]
})
export class AppModuleShared {
}



// WEBPACK FOOTER //
// ./ClientApp/app/app.shared.module.ts